module.exports = __webpack_public_path__ + "static/media/star-filled.24459476.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/AudienceBuilder/assets/star-filled.svg
// module id = 1065
// module chunks = 0